import { el, icon } from "../dom";

export function skeletonRows(rows: number, className = "skeleton skeleton--row"): HTMLElement {
  const group = el("div", { className: "skeleton-group" });
  for (let index = 0; index < rows; index += 1) group.append(el("div", { className }));
  return group;
}

export function skeletonLine(width = "100%"): HTMLElement {
  const line = el("div", { className: "skeleton skeleton--line" });
  line.style.width = width;
  return line;
}

export interface EmptyStateOptions {
  iconName: string;
  title: string;
  message: string;
  actionLabel?: string;
  onAction?: () => void;
}

export function emptyState(options: EmptyStateOptions): HTMLElement {
  const wrap = el("div", { className: "empty-state" });
  const badge = el("span", { className: "empty-state__icon" });
  badge.append(icon(options.iconName));
  wrap.append(
    badge,
    el("p", { className: "empty-state__title", text: options.title }),
    el("p", { text: options.message }),
  );
  if (options.actionLabel !== undefined && options.onAction !== undefined) {
    const action = el("button", { className: "btn btn--ghost btn--sm", text: options.actionLabel });
    action.type = "button";
    action.addEventListener("click", options.onAction);
    wrap.append(action);
  }
  return wrap;
}

export interface ErrorStateOptions {
  title: string;
  message: string;
  retryLabel?: string;
  onRetry?: () => void;
}

export function errorState(options: ErrorStateOptions): HTMLElement {
  const wrap = el("div", { className: "error-state" });
  const row = el("div", { className: "error-state__row" });
  const badge = el("span", { className: "error-state__icon" });
  badge.append(icon("i-alert"));
  const texts = el("div");
  texts.append(
    el("p", { className: "error-state__title", text: options.title }),
    el("p", { className: "error-state__text", text: options.message }),
  );
  row.append(badge, texts);
  wrap.append(row);

  if (options.onRetry !== undefined) {
    const button = el("button", { className: "btn btn--ghost btn--sm" });
    button.type = "button";
    button.append(icon("i-refresh"), el("span", { text: options.retryLabel ?? "Reintentar" }));
    button.addEventListener("click", options.onRetry);
    wrap.append(button);
  }
  return wrap;
}
